module.exports = {"360781100":"象湖镇","360781101":"瑞林镇","360781102":"壬田镇","360781103":"九堡镇","360781104":"沙洲坝镇","360781105":"谢坊镇","360781106":"武阳镇","360781200":"叶坪乡","360781201":"丁陂乡","360781202":"大柏地乡","360781203":"岗面乡","360781204":"日东乡","360781205":"万田乡","360781206":"黄柏乡","360781207":"云石山乡","360781208":"泽覃乡","360781209":"拔英乡","360781400":"江西瑞金经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/360781.json
// module id = 1303
// module chunks = 0